import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import moment from 'moment';

const styles = theme => ({
  filtersContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    padding: '23px 20px 10px',
    width: '338px'
  },
  filterRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '46px'
  },
  filterInput: {
    border: '1px solid #0133A0',
    borderRadius: '12px',
    padding: '18px 12px',
    fontSize: '14px',
    fontFamily: 'Sura Sans, system-ui',
    color: '#000000',
    fontWeight: 400,
    backgroundColor: '#FFFFFF',
    boxSizing: 'border-box',
    width: '100%',
    '&::placeholder': {
      color: '#B4B4B5'
    }
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px'
  },
  filterTitle: {
    fontSize: '14px',
    fontFamily: 'Sura Sans, system-ui',
    color: '#2D6DF6',
    fontWeight: 400
  },
  dateRangeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8%',
    width: '48%'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #dbdbdb',
    gap: '10px',
    paddingTop: '12px'
  },
  applyButton: {
    backgroundColor: '#FFFFFF',
    color: '#0133A0',
    border: '1px solid #0133A0',
    borderRadius: '28px',
    padding: '10px 23px',
    fontFamily: 'Sura Sans',
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#0133A0',
      color: '#FFFFFF'
    }
  },
  clearButton: {
    color: '#2D6DF6',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Sura Sans',
    textTransform: 'none',
    padding: '6px 23px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

const DetailPaymentFilters = ({ classes, onFilterChange, onClearAll, onClose }) => {
  const [filters, setFilters] = useState({
    receiptNumber: '',
    startDate: '',
    endDate: '',
    amount: ''
  });
  const [showDateError, setShowDateError] = useState(false);

  useEffect(() => {
    const hasOneDate = filters.startDate || filters.endDate;
    const hasBothDates = filters.startDate && filters.endDate;
    setShowDateError(hasOneDate && !hasBothDates);
  }, [filters.startDate, filters.endDate]);

  const handleFilterChange = (field) => (event) => {
    if (!event) return;
    
    const value = event.target ? event.target.value : event;
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleApply = () => {
    onFilterChange(filters);
    onClose();
  };

  const handleClear = () => {
    setFilters({
      receiptNumber: '',
      startDate: '',
      endDate: '',
      amount: ''
    });
    onClearAll();
  };

  return (
    <div className={classes.filtersContainer}>
      
      <div className={classes.filterRow}>
        <div className={classes.inputContainer}>
          <Typography className={classes.filterTitle}>Número de recibo</Typography>
          <input
            className={classes.filterInput}
            placeholder="Recibo"
            value={filters.receiptNumber}
            onChange={handleFilterChange('receiptNumber')}
            type="number"
            min="0"
            onInput={(e) => {
              e.target.value = Math.max(0, parseFloat(e.target.value)).toString().slice(0, 16);
            }}
          />
        </div>
        <div className={classes.inputContainer}>
          <Typography className={classes.filterTitle}>Inicio de Vigencia</Typography>
          <div className={classes.dateRangeContainer}>
            <input
              className={classes.filterInput}
              type="date"
              value={filters.startDate}
              onChange={handleFilterChange('startDate')}
              style={{
                color: filters.startDate ? '#000000' : '#B4B4B5',
                borderColor: showDateError && !filters.startDate ? '#FF0000' : '#0133A0'
              }}
            />
            <input
              className={classes.filterInput}
              type="date"
              value={filters.endDate}
              onChange={handleFilterChange('endDate')}
              style={{
                color: filters.endDate ? '#000000' : '#B4B4B5',
                borderColor: showDateError && !filters.endDate ? '#FF0000' : '#0133A0'
              }}
            />
          </div>
          {showDateError && (
            <Typography style={{ color: '#FF0000', fontSize: '12px', fontFamily: 'Sura Sans, system-ui', marginTop: '4px' }}>
              Ambos campos de fecha son requeridos
            </Typography>
          )}
        </div>

        <div className={classes.inputContainer}>
          <Typography className={classes.filterTitle}>Importe del Recibo</Typography>
          <input
            className={classes.filterInput}
            placeholder="Importe"
            value={filters.amount}
            onChange={handleFilterChange('amount')}
          type="number"
          min="0"
            onInput={(e) => {
              e.target.value = Math.max(0, parseFloat(e.target.value)).toString().slice(0, 10);
            }}
          />
        </div>
      </div>

      <div className={classes.buttonsContainer}>
        <Button
          className={classes.clearButton}
          onClick={handleClear}
        >
          Limpiar
        </Button>
        <Button
          className={classes.applyButton}
          onClick={handleApply}
          style={{
            opacity: 1,
            cursor: 'pointer'
          }}
        >
          Aplicar
        </Button>
      </div>
    </div>
  );
};

DetailPaymentFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default withStyles(styles)(DetailPaymentFilters); 


// WEBPACK FOOTER //
// ./src/containers/paymentMovements/components/DetailPaymentFilters.js